import React, {Component} from 'react';
import {connect} from 'react-redux';
import PayerSelect from "../invoice/PayerSelect";
import ManagePaymentMethods from "./manage-payment-methods/ManagePaymentMethods";
import * as appConstants from "../../constants/ApplicationConstants";

export class AccountPaymentPage extends Component {

  render() {
    const isSoldToAccount = this.props.accountType === appConstants.SOLD_TO_COMPARE;
    return <div className={'container'}>
      <div className="row mb-4">
        <div className="col-md-6">
          {isSoldToAccount ? <PayerSelect name={'payer_option'}/>: ''}
        </div>
      </div>
      <div className="card">
        <ManagePaymentMethods alwaysSaveOnFile={true}/>
      </div>
    </div>
  }
}

export default connect((state, props) => {
  return {
    accountType: state.user_options.accountType,
  }
})(AccountPaymentPage);
